import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@duck/ui'
import { TranslationKey, useTar } from '@/modules/i18n'

export type FeedbackLanguage = 'en' | 'he' | 'es' | 'fr' | 'de'

interface LanguageOption {
    value: FeedbackLanguage
    label: TranslationKey
    flag: string
}

const LANGUAGE_OPTIONS: LanguageOption[] = [
    { value: 'en', label: 'languages.english', flag: '🇺🇸' },
    { value: 'he', label: 'languages.hebrew', flag: '🇮🇱' },
    { value: 'es', label: 'languages.spanish', flag: '🇪🇸' },
    { value: 'fr', label: 'languages.french', flag: '🇫🇷' },
    { value: 'de', label: 'languages.german', flag: '🇩🇪' },
]

interface LanguagePickerProps {
    value?: FeedbackLanguage
    onValueChange: (value: FeedbackLanguage) => void
    disabled?: boolean
}

export const LanguagePicker = ({ value, onValueChange, disabled }: LanguagePickerProps) => {
    const { t } = useTar()

    const selectedLanguage = LANGUAGE_OPTIONS.find(opt => opt.value === value)

    return (
        <Select
            value={value}
            onValueChange={onValueChange}
            disabled={disabled}
        >
            <SelectTrigger className="w-[200px]">
                <SelectValue>
                    {selectedLanguage ? (
                        <div className="flex items-center gap-2">
                            <span>{selectedLanguage.flag}</span>
                            <span>{t(selectedLanguage.label)}</span>
                        </div>
                    ) : (
                        <span className="text-muted-foreground">{t('common.select')}</span>
                    )}
                </SelectValue>
            </SelectTrigger>
            <SelectContent>
                {LANGUAGE_OPTIONS.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                        <div className="flex items-center gap-2">
                            <span>{option.flag}</span>
                            <span>{t(option.label)}</span>
                        </div>
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}
